import { Spinner } from '@components/Spinner';
import { LocalizationContext } from '@contexts/localization-context';
import { roundToHundred } from '@lib/format';
import { RentProjectionResponse } from '@models/RentProjectionResponse';
import { DollarSignIcon } from '@src/assets';
import React, { useContext } from 'react';
import { UnitFeatures } from '../../../codecs/revenueEstimate';
import * as styled from './styled/AnnualRevenueEstimate.styled';

export const AnnualRevenueEstimate: React.FC<{
    estimate?: RentProjectionResponse | UnitFeatures;
    isLoading?: boolean;
    predictionPercentError?: number;
}> = ({ estimate, isLoading }) => {
    const localization = useContext(LocalizationContext);

    const formatter = new Intl.NumberFormat(localization.language);
    const estimateString = '--------';
    let estimateValues = null;
    if (
        estimate &&
        estimate.prediction_band_low &&
        estimate.prediction_band_high &&
        estimate.annualPrediction
    ) {
        estimateValues = {} as any;
        estimateValues.low = formatter.format(roundToHundred(estimate.prediction_band_low));
        estimateValues.medium = formatter.format(roundToHundred(estimate.annualPrediction));
        estimateValues.high = formatter.format(roundToHundred(estimate.prediction_band_high));
    }
    const spanStyle = {
        width: '150px',
        display: 'inline-block',
    };
    return (
        <styled.AnnualRevenueEstimate>
            {!estimateValues && <DollarSignIcon />}
            <span>
                {!isLoading && estimateValues && (
                    <>
                        <div>
                            <span style={spanStyle}>Low:</span>${estimateValues.low}
                        </div>
                        <div>
                            <span style={spanStyle}>Medium:</span>${estimateValues.medium}
                        </div>
                        <div>
                            <span style={spanStyle}>High:</span>${estimateValues.high}
                        </div>
                    </>
                )}
                {!isLoading && !estimateValues && <>{estimateString}</>}
                {isLoading && <Spinner />}
            </span>
        </styled.AnnualRevenueEstimate>
    );
};
